import React from 'react'
import { Container, Col, Row, Form, Button} from 'react-bootstrap'
import questionsAll from './Helpers/QuestionDB'
import {getContactsList, createContact} from './Helpers/sib';
import { withRouter } from 'react-router-dom'
import parse from "html-react-parser"
import './App.css'
import logo from "./assets/logo-vinidaily-white.png"
import right_arrow from "./assets/right-arrow.png"
import left_arrow from "./assets/left-arrow.png"
import profiles_desc from './Helpers/profileDescription'
import vigne from './assets/feuille-vigne-314x261.svg'
import grappe from './assets/grappe-171x365.svg'
import barrique from './assets/barrique-243x279.svg'

class QuestionProfile extends React.Component {  
    constructor(){
        super();

        this.state = {
            questionsAll : questionsAll,
            CheckBox : this.checkBoxInit(),
            form_complete : false,
            email: "",
            phone: "",
            showForm: true,
            showEmail:false,
            newsletter: false,
            pcAgreement:false,
            rgpdOk: false
        }
    }

    componentDidMount(){
    console.log(this.props)
      if(this.props.showEmail){
        this.setState({
            email: this.props.email,
            showEmail: this.props.showEmail
          })
      }
      else{
        this.setState({
            email: this.props.match.params.email,
            showEmail: this.props.showEmail
          })
      }
    }

    setStateSync(state){
        return new Promise(resolve=>{
            this.setState(state,resolve)
        })
    }

    checkBoxInit(){
        var CheckBoxResults = []
        questionsAll.forEach((question) => {
            if (question.type === "user_profil"){
                question.answers.forEach((answer) => {
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                })
            }
        })
        return CheckBoxResults
    }
    isFormComplete(){
        var state = []
        for (let i=1; i<5;i++){
            state = this.state.CheckBox.filter((obj) => (obj.value === true) && (~~(obj.id/10)===i))
            if (state.length !== 1){
                return false
            }
        }
        this.onPressButton1()
        return true
    }


    async handleCheckChanges(id){
        var CheckBoxResults = []
        var answerState = this.state.CheckBox.filter((obj) => obj.id === id)[0].value
        if( answerState === true ) {
            this.state.CheckBox.forEach((answer) => {
                if (~~(answer.id/10) === ~~(id/10)){
                    CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                }
                else{
                    CheckBoxResults = CheckBoxResults.concat(answer)
                }
            })
        }
        else{
            this.state.CheckBox.forEach((answer) => {
                if (~~(answer.id/10) === ~~(id/10)){
                    if (answer.id === id){
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: true, score: answer.score})
                    }
                    else{
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                    }
                }
                else{
                    CheckBoxResults = CheckBoxResults.concat(answer)
                }
            })
        }
        await this.setStateSync({
            CheckBox : CheckBoxResults
        })
        // if isFormComplete
        this.setStateSync({
            form_complete : this.isFormComplete()
        })

    }


    getCheckboxState(id){
        var state = this.state.CheckBox.filter((obj) => obj.id === id)
        return state[0].value
    }

    async onPressButton1(){
      const profil = this.getProfil()
      await this.setStateSync({
          Profil: profil,
          showForm: false
      })
      if(this.state.email.length > 0){
        await getContactsList(this.state.email, this.state.phone, this.state.showEmail, profil, this.state.newsletter)
      }
    }


    getProfil(){
      var userScore = 0
      this.state.CheckBox.forEach((answer) => {
          if (answer.value === true){
              userScore += answer.score
          }
      })
      var profil = userScore <  3 ?  1 : (userScore <  6 ?  2 : 3)
      return profil

  }

  answerRendering(answer){
      return(
        <Row key={answer.id}>
          <label className="choice"> 
            <input
                className="option-input checkbox"
                type= 'checkbox'
                content="\f111"
                key={answer.id}
                title={answer.a_content}
                checked= {this.state.CheckBox.filter((obj) => obj.id === answer.id)[0].value}
                onChange = {()=>this.handleCheckChanges(answer.id)}/>
                {answer.a_content}
            </label>
        </Row>
      )
  }
  getLogo(prof){
      if(prof.logo === "vigne"){
        return vigne
      }
      else if(prof.logo === "grappe"){
        return grappe
      }
      else if(prof.logo === "barrique"){
        return barrique
      }

  }

  renderProfile(prof){
    return (
        <div> 
            <img alt="Mon Profil" className="profile-logo"src={this.getLogo(prof)} />
            <h1 style={{color:"#ef8277", fontWeight: "200"}}>Votre profil est {parse(prof.name)}</h1>
            <p className="profile-desc" >{parse(prof.description1)}</p>
            <p className="profile-desc" >{parse(prof.description2)}</p>
            <h2 className="profile-adj" >{prof.adj}</h2>
            <p className="profile-desc" >{parse(prof.description3)}</p>
        </div>
    )
  }

  handleChangePhone(e){
    // if (e.target.value){
        this.setState({
            phone: e.target.value
        })
    // }
  }

  handleChangeMail(e){
    // if (e.target.value){
        this.setState({
            email: e.target.value
        })
    // }
  }
  handleCheckNews(e){
    this.setState({
        newsletter: e.target.checked
    })
  }
  handleCheckPC(e){
    this.setState({
        pcAgreement: e.target.checked
    })
  }

  submit(e){
    e.preventDefault();
    this.setState({
        rgpdOk: this.state.pcAgreement,
    })
    createContact(this.state.email, this.state.phone, this.state.newsletter)
    
  }

  renderForm(){
    return (
        <Form onSubmit={(e)=>this.submit(e)} >
                <h4 className="card-title" style={{color:"#147880",textAlign:"center", fontSize: "1.2rem", fontWeight:700}}>Pour suivre l'aventure et tester l'application en exclusivité !</h4>
                <Form.Group className="input-form" controlId="formBasicEmail" style={{marginTop:35}}>
                    <Form.Label style={{ fontWeight:600}}>Adresse mail (facultatif)   </Form.Label>
                    <Form.Control 
                        className="inputr"
                        style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                        type="email"
                        value={this.state.email}
                        placeholder="Votre mail  "
                        onChange={e => this.handleChangeMail(e)}/>
                </Form.Group>

                <Form.Group className="input-form" controlId="formBasicPassword">
                    <Form.Label style={{ fontWeight:600}}>Téléphone (facultatif)   </Form.Label>
                    <Form.Control
                        className="inputr"
                        style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                        type="phone" 
                        value={this.state.phone}
                        placeholder="Votre numéro 06..." 
                        onChange={e => this.handleChangePhone(e)}/>
                </Form.Group>

                <Form.Group className="check-input" controlId="formBasicPassword" style={{display:"flex",marginTop:35}}>
                        <Form.Check
                            required
                            className="inputr"
                            onChange={e => this.handleCheckPC(e)}/>
                            <Form.Label style={{ marginLeft:"25px"}}>J'accepte la <a href="https://www.vinidaily.com/politique-de-confidentialit%C3%A9"> politique de confidentialité </a>   </Form.Label>
                </Form.Group>

                <Form.Group className="check-input" controlId="formBasicPassword" style={{display:"flex",  marginTop:10}}>
                    <Form.Check
                        className="inputr"
                        onChange={e => this.handleCheckNews(e)}/>
                    <Form.Label style={{ marginLeft:"25px"}}> J'accepte de recevoir la newsletter de Vinidaily </Form.Label>
                </Form.Group>

            <Form.Group style={{display : "flex"}}>
                <Button
                    className="submit"
                    type="submit">
                    Découvrir mon profil</Button>
            </Form.Group>
        </Form>
    )
  }

  render() {
      return (
        <Container>
            <Container className="container1">
                <Container className="container2">
                <Row className="logo">
                        <img alt="Vinidaily" src={logo}/>
                </Row>
                {!this.state.showForm && this.state.form_complete && this.state.Profil &&
                (<Row className="arrow" onClick={()=> {this.setState({showForm: true})}}>
                        <img alt="Précédent" src={left_arrow}/>
                </Row>)}
                {this.state.showForm && this.state.form_complete && this.state.Profil &&
                (<Row className="arrow" onClick={()=> {this.setState({showForm: false})}}>
                        <img alt="Suivant" src={right_arrow}/>
                </Row>)}
                {this.state.showEmail && this.state.showForm && !this.state.rgpdOk && (
                    <Row className="d-flex justify-content-center mt-100">
                        <Col className="card" >
                            <div  className="card-body" >
                                <div> 
                                    {this.renderForm()}
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
                {this.state.showForm && (this.state.rgpdOk || !this.state.showEmail) && (
                    this.state.questionsAll.map((question) => (
                    <Row key={question.id} className="d-flex justify-content-center mt-100">
                        <Col className="card" >
                            <div  className="card-body" >
                            <div> 
                            <h4 className="card-title" >{question.q_content}</h4>
                                {question.answers.map(
                                    (answer) => (this.answerRendering(answer))
                                )}
                            </div>
                            </div>
                        </Col>
                    </Row>
                )))}
                </Container>
            </Container>

            {!this.state.showForm && this.state.form_complete && this.state.Profil && 
            (<>
            <Container className="container3">
                <Container className="container2">
                <Row className="profil">
                            <Row className="d-flex justify-content-center ">
                                <Col className="card-profile" >
                                    <div  className="card-body" >
                                        {this.renderProfile(profiles_desc.find(item => item.profile === this.state.Profil))}
                                    </div>
                                    

                                </Col>
                            </Row>
                </Row>
                </Container>
            </Container>
            
            <Container className="container4">
                <Container className="container2">
                    <Row className="button-profile-container">
                        <a href={profiles_desc.find(item => item.profile === this.state.Profil).url} style={{textDecoration:"none"}}>
                            <div className="button-profile-shop" >
                                <p>Retrouvez notre sélection de vins adaptés à votre profil  &#8680;</p>
                            </div>
                        </a>
                    </Row>
                </Container>
            </Container>
            </>)
        }
        </Container>
      )
  }
}

// styles = {
//   toggleButton:{
//     position: 'relative',
//     display: 'flex',
//     flexDirection: 'column',
//     minWidth: 0,
//     wordWrap: 'break-word',
//     backgroundColor: '#fff',
//     backgroundClip: 'border-box',
//     border: '1px solid #d2d2dc',
//     borderRadius: 0
//   }
// }


export default withRouter(QuestionProfile)